<template>
    <div class="item-question-input-text">
        <text-input v-if="question.fieldType === 'text'"
                    :error-text="translate('label.this_value_is_required')"
                    :field-id="question.questionId"
                    :help-text="question.additionalInfo"
                    :input-class="'form-control question-input-text-single'"
                    :label="labelContent"
                    :label-class="'text-color-questions'"
                    :model-answer="question.answer"
                    :name="fieldName"
                    :placeholder="question.placeholder ? question.placeholder : 0"
                    :required="question.required ? 1 : 0"
                    :type="'text'"
                    :validation="validationRules"
                    :has-submitted="hasSubmitted"
                    @update:modelAnswer="changeValue($event, question)"/>

        <text-input v-if="question.fieldType === 'email'"
                    :error-text="translate('label.this_value_is_required')"
                    :field-id="question.questionId"
                    :help-text="question.additionalInfo"
                    :input-class="'form-control question-input-text-single'"
                    :label="labelContent"
                    :label-class="'text-color-questions'"
                    :model-answer="question.answer"
                    :name="fieldName"
                    :placeholder="question.placeholder ? question.placeholder : 0"
                    :required="question.required ? 1 : 0"
                    :type="'email'"
                    :validation="validationRules"
                    :has-submitted="hasSubmitted"
                    @update:modelAnswer="changeValue($event, question)"/>

        <text-input v-if="question.fieldType === 'number'"
                    :error-text="translate('label.this_value_is_required')"
                    :field-id="question.questionId"
                    :help-text="question.additionalInfo"
                    :input-class="'form-control question-input-text-single'"
                    :label="labelContent"
                    :label-class="'text-color-questions'"
                    :model-answer="question.answer"
                    :name="fieldName"
                    :placeholder="question.placeholder ? question.placeholder : 0"
                    :required="question.required ? 1 : 0"
                    :type="'email'"
                    :validation="validationRules"
                    :has-submitted="hasSubmitted"
                    @update:modelAnswer="changeValue($event, question)"/>

        <select-input v-if="question.fieldType === 'countries'"
                      :error-text="translate('label.this_value_is_required')"
                      :field-id="question.questionId"
                      :help-text="question.additionalInfo"
                      :input-class="'form-select question-input-text-select'"
                      :label="labelContent"
                      :label-class="'text-color-questions'"
                      :model-answer="question.answer"
                      :name="fieldName"
                      :options="getCountries"
                      :question="question"
                      :required="question.required"
                      :text-select="translateLabels.textSelect"
                      :type="'email'"
                      :validation="validationRules"
                      :has-submitted="hasSubmitted"
                      @update:modelAnswer="changeValue($event, question)"/>

        <text-input v-if="question.fieldType === 'states'"
                    :error-text="translate('label.this_value_is_required')"
                    :field-id="question.questionId"
                    :help-text="question.additionalInfo"
                    :input-class="'form-control question-input-text-single'"
                    :label="labelContent"
                    :label-class="'text-color-questions'"
                    :model-answer="question.answer"
                    :name="fieldName"
                    :placeholder="question.placeholder ? question.placeholder : 0"
                    :required="question.required ? 1 : 0"
                    :type="'email'"
                    :validation="validationRules"
                    :has-submitted="hasSubmitted"
                    @update:modelAnswer="changeValue($event, question)"/>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import TextInput from "../components/text-input.vue";
import SelectInput from "../components/select-input.vue";
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORE & COMPOSABLES
const playerStore = usePlayerStore();
const { translate } = useTranslation();

// PROPS & EMITS
const props = defineProps({
    question: {
        type: Object,
        required: true,
    },
    translateLabels: {
        type: Object,
        required: true,
    },
    TYPE_FIELD_ID: {
        type: Number,
        required: true,
    },
    store: {
        type: Object,
        required: true
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['field-change', 'register-field']);

// REACTIVE VARIABLES
const countries = ref({});
//const blackList = ref('');

// COMPUTED PROPERTIES
const fieldName = computed(() =>
    `question_${props.TYPE_FIELD_ID}_${props.question.questionId}_${props.question.fieldType}`
);

const validationRules = computed(() => {
    const rules = {
        required: false,
        email: false,
        numeric: false,
    };
    if (props.question.required) {
        rules.required = true;
    }
    if (props.question.fieldType === 'email') {
        rules.email = true;
    }
    if (props.question.fieldType === 'number') {
        rules.numeric = true;
    }

    return rules;
});

const labelContent = computed(() => {
    return props.question.description;
});

const getCountries = computed(() => {
    return countries.value;
});

// METHODS
/*const domainBlackList = ({ value }) => {
    const pattern = "\\^*(" + blackList.value + ")$";
    const re = new RegExp(pattern, 'g');
    return !re.test(value);
};

const domainBlackListMessage = ({ value }) => {
    const domain = value.substring(value.lastIndexOf("@") + 1);
    return `Use another email address. The ${domain} domain is not allowed.`;
};*/

const changeValue = (newValue, qt) => {
    qt.answer = newValue;
    emit('field-change', fieldName.value, newValue);
    playerStore.setAnswerInFormQuestions(qt);
};

// Registrar el campo al montar el componente
onMounted(async () => {
    // Registrar este campo en el formulario padre
    emit('register-field', fieldName.value, props.question.answer || '');

    if (props.question.fieldType === 'countries') {
        countries.value = playerStore.getCountriesData;
    }
});
</script>
